import View from "./View";
import { RouterView } from '../utils';

function UnknownView(props) {
  return (
    <View title='Unknown View'>Content Not Found</View>
  )
}

export default RouterView(UnknownView);